import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/layouts/custom.vue").then(m => m.default || m))
}